export default "__VITE_ASSET__bdf2a8e9__"